module.exports = __webpack_public_path__ + "img/introduce.d12ba4b3.png";